import clsx from "clsx";
import styles from "./C03_AnchorHeading.module.scss";

export interface AnchorHeadingProps {
  mainTitle: string;
  description: string;
  pageTitle: string;
  anchorKey: string;
}

export const AnchorHeading = (props: { content: AnchorHeadingProps }) => {
  const { content } = props;
  const { mainTitle, description, pageTitle, anchorKey } = content;
  const cleanAnchor = anchorKey?.replace(/\s+/g, "");

  const trimmedMainTitle = mainTitle?.trim();
  const trimmedDescription = description?.trim();
  const trimmedPageTitle = pageTitle?.trim();

  const showStandalonePageTitle =
    !trimmedMainTitle && !trimmedDescription && trimmedPageTitle;

  const topHeading = trimmedPageTitle ? (
    <h2 id={cleanAnchor}>{pageTitle}</h2>
  ) : (
    <div id={cleanAnchor} />
  );

  let leftHeading;

  if (trimmedMainTitle) {
    leftHeading = trimmedPageTitle ? (
      <h3>{mainTitle}</h3>
    ) : (
      <h2 id={cleanAnchor}>{mainTitle}</h2>
    );
  } else {
    leftHeading = <div id={cleanAnchor} />;
  }

  return (
    <div className={clsx("component", "wrapper", styles["subnav-header"])}>
      {showStandalonePageTitle ? (
        <h2 id={cleanAnchor}>{pageTitle}</h2>
      ) : (
        <>
          <div className={styles["top-heading"]}>{topHeading}</div>
          <div className={styles["title-with-intro"]}>
            <div className={styles["left-section"]}>{leftHeading}</div>
            <div className={styles["right-section"]}>
              <p>{description}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AnchorHeading;
